import ftMyers01 from "../assets/ig-ft-myers-01.webp";
import ftMyers02 from "../assets/ig-ft-myers-02.webp";
import ftMyers03 from "../assets/ig-ft-myers-03.webp";
import ftMyers04 from "../assets/ig-ft-myers-04.webp";
import ftMyers05 from "../assets/ig-ft-myers-05.webp";
import ftMyers06 from "../assets/ig-ft-myers-06.webp";
import ftMyers07 from "../assets/ig-ft-myers-07.webp";
import ftMyers08 from "../assets/ig-ft-myers-08.webp";
import ftMyers09 from "../assets/ig-ft-myers-09.webp";
import bamFullBand from "../assets/bam-full-band.jpg";
import bamVocals from "../assets/bam-vocals.jpg";
import bamGuitars from "../assets/bam-guitars.jpg";
import rockNBarrel from "../assets/ig-rocknbarel.webp";
import redWhiteBlues from "../assets/ig-redwhiteblues.webp";
import halloween from "../assets/ig-halloween.webp";
import halloweenParty from "../assets/ig-halloween-party.webp";
import endOfTour from "../assets/ig-endoftour.webp";
import rockHall from "../assets/ig-rockhall.webp";
import musicYard from "../assets/ig-musicyard.webp";
import tourPittsboro from "../assets/ig-tour-pittsboro-2026.jpg";
import tourPhiladelphia from "../assets/ig-tour-philadelphia-2026.jpg";
import tourBand from "../assets/ig-tour-band-2026.jpg";
import tourSeaside from "../assets/ig-tour-seaside-2026.jpg";
import tourNewYork from "../assets/ig-tour-new-york-2026.jpg";
import bridgewaterFlyer from "../assets/bridgewater-fall-festival-2026.jpg";

export const tour = {
  year: 2027,
  fundraiserUrl: "https://gofund.me/e7e8e1f7d",
  instagramUrl: "https://www.instagram.com/sor_lwr_houseband",
  instagramHandle: "@sor_lwr_houseband",
  bookingEmail: "andrea@mainbranch.dev",
} as const;

export const scheduledShows = [
  {
    id: "bridgewater-fall-festival-2026",
    title: "Bridgewater Fall Festival",
    venue: "Bridgewater Community Park",
    startsAt: "2026-10-18T16:00:00-04:00",
    endsAt: "2026-10-18T18:00:00-04:00",
    flyer: bridgewaterFlyer,
    description:
      "Food, music, and fun. More event details are coming from the community's social committee.",
  },
  {
    id: "trunk-or-treat-2026",
    title: "Trunk or Treat",
    venue: "School of Rock Lakewood Ranch",
    startsAt: "2026-10-25T17:00:00-04:00",
    endsAt: "2026-10-25T21:00:00-04:00",
    description: "Midseason debut in the school parking lot.",
  },
  {
    id: "red-white-blues-2026",
    title: "Red White & Blues",
    venue: "Lake Worth Beach",
    startsAt: "2026-11-08T12:00:00-05:00",
    endsAt: "2026-11-08T20:00:00-05:00",
    description: "Annual mini tour stop in Lake Worth Beach.",
  },
  {
    id: "manatee-library-xmas-2026",
    title: "Manatee Library Xmas Show",
    venue: "Manatee Library",
    startsAt: "2026-12-11T15:30:00-05:00",
    endsAt: "2026-12-11T20:00:00-05:00",
  },
  {
    id: "woodys-river-room-2027",
    title: "Woody's River Room",
    venue: "Woody's River Room",
    startsAt: "2027-01-10T17:30:00-05:00",
    endsAt: "2027-01-10T21:30:00-05:00",
  },
] as const;

export const instruments = ["Drums", "Guitar", "Vocals", "Bass"] as const;
export type Instrument = (typeof instruments)[number];

export const members: { name: string; role: Instrument }[] = [
  { name: "Ryland K", role: "Drums" },
  { name: "Max B", role: "Drums" },
  { name: "Anberlyn W", role: "Drums" },
  { name: "Kelsey M", role: "Drums" },
  { name: "Max F", role: "Guitar" },
  { name: "Parks G", role: "Guitar" },
  { name: "Finn G", role: "Guitar" },
  { name: "Carver C", role: "Guitar" },
  { name: "Emma G", role: "Vocals" },
  { name: "Molly M", role: "Vocals" },
  { name: "Lanae C", role: "Vocals" },
  { name: "Chase D", role: "Bass" },
  { name: "Ben S", role: "Bass" },
];

interface ArchivePhoto {
  id: string;
  src: string;
  responsiveBase?: string;
  alt: string;
  caption: string;
  date: string;
  year: number | null;
  sourceUrl?: string;
  credit?: string;
  featured?: boolean;
}

export const archivePhotos: ArchivePhoto[] = [
  { id: "tour-pittsboro-2026", src: tourPittsboro, responsiveBase: "ig-tour-pittsboro-2026", alt: "A House Band musician playing a kazoo on stage during the Pittsboro tour stop", caption: "Live in Pittsboro", date: "Posted July 2, 2026", year: 2026, sourceUrl: "https://www.instagram.com/sor_lwr_houseband/p/DaTKxXujnBq/", credit: "@mm.muzak" },
  { id: "tour-philadelphia-2026", src: tourPhiladelphia, responsiveBase: "ig-tour-philadelphia-2026", alt: "A House Band guitarist performing under blue stage lights on the 2026 tour", caption: "Turned up in Philadelphia", date: "Posted June 27, 2026", year: 2026, sourceUrl: "https://www.instagram.com/sor_lwr_houseband/p/DaGF64QDpTg/", credit: "@mm.muzak", featured: true },
  { id: "tour-band-2026", src: tourBand, responsiveBase: "ig-tour-band-2026", alt: "The previous House Band lineup posing together during the 2026 summer tour", caption: "The band, on the road", date: "Posted June 26, 2026", year: 2026, sourceUrl: "https://www.instagram.com/sor_lwr_houseband/p/DaD0HBiGFgV/", featured: true },
  { id: "tour-seaside-2026", src: tourSeaside, responsiveBase: "ig-tour-seaside-2026", alt: "A House Band vocalist singing into a microphone under pink stage lights", caption: "Seaside Heights, live", date: "Posted June 25, 2026", year: 2026, sourceUrl: "https://www.instagram.com/sor_lwr_houseband/p/DaBVSbRmDja/", credit: "@mm.muzak", featured: true },
  { id: "tour-new-york-2026", src: tourNewYork, responsiveBase: "ig-tour-new-york-2026", alt: "The Statue of Liberty during the House Band's New York tour stop", caption: "A New York state of mind", date: "Posted June 24, 2026", year: 2026, sourceUrl: "https://www.instagram.com/sor_lwr_houseband/p/DZ_AW3juFWy/" },
  { id: "ft-myers-01", src: ftMyers01, responsiveBase: "ig-ft-myers-01", alt: "Two House Band guitarists playing together in Fort Myers", caption: "Turned up in Fort Myers", date: "From the archive", year: null },
  { id: "bam-band", src: bamFullBand, alt: "The previous House Band lineup performing outdoors at BAM!Fest", caption: "Live at BAM!Fest", date: "March 2026", year: 2026 },
  { id: "bam-vocals", src: bamVocals, alt: "House Band vocalists sharing the stage at BAM!Fest", caption: "Voices of BAM!Fest", date: "March 2026", year: 2026 },
  { id: "bam-guitars", src: bamGuitars, alt: "House Band guitarists performing at BAM!Fest", caption: "A little louder at BAM!Fest", date: "March 2026", year: 2026 },
  { id: "ft-myers-02", src: ftMyers02, responsiveBase: "ig-ft-myers-02", alt: "House Band musicians performing in Fort Myers", caption: "Fort Myers, live", date: "From the archive", year: null },
  { id: "ft-myers-03", src: ftMyers03, responsiveBase: "ig-ft-myers-03", alt: "A moment from the House Band's Fort Myers performance", caption: "On stage in Fort Myers", date: "From the archive", year: null },
  { id: "ft-myers-04", src: ftMyers04, responsiveBase: "ig-ft-myers-04", alt: "House Band on stage at Nauti Parrot Oasis", caption: "Nauti Parrot Oasis", date: "From the archive", year: null },
  { id: "ft-myers-05", src: ftMyers05, responsiveBase: "ig-ft-myers-05", alt: "House Band playing live in Fort Myers", caption: "More from Fort Myers", date: "From the archive", year: null },
  { id: "ft-myers-06", src: ftMyers06, responsiveBase: "ig-ft-myers-06", alt: "House Band playing together at the Fort Myers show", caption: "Better together", date: "From the archive", year: null },
  { id: "ft-myers-07", src: ftMyers07, responsiveBase: "ig-ft-myers-07", alt: "House Band musicians during a live performance", caption: "In the middle of the music", date: "From the archive", year: null },
  { id: "ft-myers-08", src: ftMyers08, responsiveBase: "ig-ft-myers-08", alt: "House Band performance at the Fort Myers show", caption: "The Fort Myers set", date: "From the archive", year: null },
  { id: "ft-myers-09", src: ftMyers09, responsiveBase: "ig-ft-myers-09", alt: "Another moment from the House Band's Fort Myers show", caption: "One more from Fort Myers", date: "From the archive", year: null },
  { id: "rock-n-barrel", src: rockNBarrel, alt: "House Band performing at Rock 'N Barel with School of Rock St. Pete", caption: "Rock 'N Barel with SoR St. Pete", date: "December 2025", year: 2025 },
  { id: "red-white-blues", src: redWhiteBlues, alt: "House Band at Red White & Blues", caption: "Red White & Blues", date: "November 2025", year: 2025 },
  { id: "halloween", src: halloween, alt: "House Band performing at the Halloween street festival in St. Pete", caption: "Halloween on Central", date: "October 2025", year: 2025 },
  { id: "halloween-party", src: halloweenParty, alt: "Halloween party at School of Rock Lakewood Ranch", caption: "Halloween at School of Rock", date: "October 2025", year: 2025 },
  { id: "end-of-tour", src: endOfTour, alt: "The 2025 House Band lineup together at the end of their tour", caption: "That's a wrap, 2025", date: "July 2025", year: 2025 },
  { id: "rock-hall", src: rockHall, alt: "House Band performing at the Rock & Roll Hall of Fame", caption: "Rock & Roll Hall of Fame", date: "July 2025", year: 2025 },
  { id: "music-yard", src: musicYard, alt: "House Band performing at The Music Yard in Charlotte", caption: "The Music Yard, Charlotte", date: "July 2025", year: 2025 },
];

export function photoSrcSet(photo: ArchivePhoto) {
  return photo.responsiveBase
    ? `/images/${photo.responsiveBase}-480.webp 480w, /images/${photo.responsiveBase}-960.webp 960w, ${photo.src} 1440w`
    : undefined;
}
